import { BrandLockup } from '../../components/BrandLockup.js'
import { useSessionStore } from '../../state/session-store.js'
import { UserMenu } from '../../app/UserMenu.js'
import styles from './AdminView.module.css'

/**
 * What SYSTEM_SUPPORT and SYSTEM_ADMIN see: support users and super admins from Teamcentric
 * Accounts sign in and nothing more, as the API refuses them everything else. The app
 * switcher opens Accounts.
 */
export function SupportView() {
  const superAdmin = useSessionStore((state) => state.user?.role === 'SYSTEM_ADMIN')
  return (
    <div className={styles.page}>
      <header className={styles.topBar}>
        <div className={styles.topRow}>
          <span className={styles.brand}>
            <img className={styles.logo} src="/logo-mark.png" alt="" width={34} height={18} />
            <BrandLockup />
          </span>
          <span className={styles.spacer} />
          <UserMenu />
        </div>
      </header>

      <div className={styles.scroll}>
        <div className={styles.inner}>
          <header className={styles.masthead}>
            <div className={styles.headings}>
              <h1 className={styles.title}>{superAdmin ? 'Signed in as teamcentric super admin' : 'Signed in as teamcentric support'}</h1>
              <p className={styles.subtitle}>
                {superAdmin ? 'Tenants and feedback are administered at teamcentric Accounts.' : 'Feedback is administered at teamcentric Accounts.'}
              </p>
            </div>
          </header>
        </div>
      </div>
    </div>
  )
}
